import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';

export const useErrorHandler = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleError = useCallback((error, userMessage = 'Something went wrong') => {
    console.error('Error occurred:', error);
    setError(error);
    
    // Show user-friendly toast notification
    toast.error(userMessage, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    
    // Log to error reporting service if available
    if (window.logErrorToService) {
      window.logErrorToService(error, { userMessage });
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const executeWithErrorHandling = useCallback(async (asyncFunction, loadingMessage, errorMessage) => {
    try {
      setIsLoading(true);
      setError(null);
      
      if (loadingMessage) {
        toast.info(loadingMessage, { autoClose: 2000 });
      }
      
      const result = await asyncFunction();
      return result;
    } catch (err) {
      handleError(err, errorMessage || 'Operation failed');
      throw err; // Re-throw so caller can handle if needed
    } finally {
      setIsLoading(false);
    }
  }, [handleError]);

  return { 
    error, 
    isLoading,
    handleError, 
    clearError, 
    executeWithErrorHandling 
  };
};